module.exports = __webpack_public_path__ + "static/media/icon-mouth2@3x.6e14c78e.png";